export default __webpack_public_path__ + "/dist/images/Diamond.a828daaf641a0951455eb1df3de90338.svg";